import React, {Component} from 'react';
import Content from './Content';
import PageRoutes from './components/PageRoutes'
import './css/App.css';


class App extends Component {
    constructor(props){
        super(props);
        var content = new Content();

        var country;
        if(window.location.origin.indexOf(".com")!== -1){
            country = "US";
        } else {
            country = "CA";
        }
        var res;
        res = this.getQueryString();
        if(res.country !== undefined){
            country = res.country;
        }

        this.state = {
            settings:{
                language:res.lang,
                country:country
            },
            page: res.page,
            app_data:{
                content:content
            }

            };


            this.setCountry = this.setCountry.bind(this);
            this.setLanguage = this.setLanguage.bind(this);
            this.setPage = this.setPage.bind(this);


        }

    setCountry(country){
        var settings = this.state.settings;
        var page = this.state.page;
        var query_string;
        var host;

        if (country === "US"){
           host = window.location.protocol + "//www.vetradent.com";
        } else if (country === "CA"){
           host = window.location.protocol + "//www.vetradent.ca";
        }

        if(settings.country !== country){
            query_string = host + "/?page=" +page +"&lang=en&country="+country;
            window.location = query_string;
        }

    }

    setLanguage(language){
        var settings = this.state.settings;
        var page = this.state.page;
        var query_string;

        if(settings.language !== language){
            settings.language = language;
            this.setState({settings});
            query_string = window.location.origin + "?page=" +page +"&lang="+settings.language + "&country="+settings.country;
            window.history.pushState({}, "Vetradent by Dechra", query_string);
        }
    }

    setPage(page){
        var settings = this.state.settings
        var curr_page = this.state.page

        if(curr_page !== page){
            var query_string = "";
            query_string = window.location.origin + "?page=" +page +"&lang="+settings.language + "&country="+settings.country;
            curr_page = page;
            this.setState({page:curr_page});

            window.history.pushState({}, "Vetradent by Dechra", query_string);

        }



    }

    getQueryString() {
        var search = window.location.search.split("?");
        var result = {};
        result.page = "home";
        result.lang = "en";

        if(search.length >= 2){
            var params = search[1].split("&");

            for (var x = 0; x < params.length; ++x) {
                var param = params[x].split("=");
                switch (param[0]) {
                    case "page":
                        result.page = param[1];
                        break;
                    case "lang":
                        result.lang = param[1];
                        break;
                    case "country":
                        result.country = param[1];
                        break;
                    default:
                        break;
                }
            }
        }

        return result;
    }




    render(){
        return(
            <div className = "backsplash">
                <div className = "container">


                    <PageRoutes
                        Settings = {this.state.settings}
                        Content = {this.state.app_data.content}
                        Page = {this.state.page}
                        setPage = {this.setPage}
                        setCountry = {this.setCountry}
                        setLanguage = {this.setLanguage}
                        />
                </div>
            </div>);
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js